import { Injectable } from "@angular/core";
import { UserSessionService } from "../user-session/user-session.service";
import { WebservicesService } from "../webservices/webservices.service";
import { PlatformResponse } from "src/app/interfaces/webservices-interface";
import { ConfigService } from "../config/config.service";
import { Subject, Subscription } from "rxjs";
import { distinctUntilChanged, map, filter } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class PurchaseService {
  public customerId: string;
  private customerSubscription: Subscription | null = null;

  constructor(
    private userSession: UserSessionService,
    private webservices: WebservicesService,
    private config: ConfigService
  ) {
    this.getCustomer();
  }

  public purchaseCoins(params): Subject<PlatformResponse<any>> {
    params.customer_id = this.customerId;
    params.session_token = this.userSession.sessionToken;
    params.clientapp = this.config.getClientApp();

    return this.webservices.post("product/purchase", params as any);
  }

  public breakPiggy(params) {
    params.customer_id = this.customerId;
    params.session_token = this.userSession.sessionToken;
    params.clientapp = this.config.getClientApp();

    return this.webservices.post("bonus/break-piggy", params as any);
  }
  getCustomerPremiumPurchases(): Subject<PlatformResponse<any>> {
    const params = {
      customer_id: this.customerId,
      session_token: this.userSession.sessionToken,
      clientapp: this.config.getClientApp(),
    };
    return this.webservices.get(
      "product/get-customer-premium-purchases",
      params as any
    );
  }
  getPremiumPurchases(): Subject<PlatformResponse<any>> {
    const params = {
      session_token: this.userSession.sessionToken,
      clientapp: this.config.getClientApp(),
      customer_id: this.customerId,
    };
    return this.webservices.get("product/get-premium-purchases", params as any);
  }
  getAvailablePurchases(): Subject<PlatformResponse<any>> {
    const params = {
      customer_id: this.customerId,
      session_token: this.userSession.sessionToken,
      clientapp: this.config.getClientApp(),
    };

    return this.webservices.get(
      "product/get-available-purchases",
      params as any
    );
  }
  getAllPurchases(externalVendor) {
    return this.webservices.get(
      `product/get-external-vendor-purchases?vendor=${externalVendor}`
    );
  }

  public getCustomer() {
    if (this.customerSubscription) {
      try {
        this.customerSubscription.unsubscribe();
      } catch (error) {
        console.error("Error when trying to unsubscribe:", error);
      }
      this.customerSubscription = null;
    }

    this.userSession.getCustomerSubscription().then((obs) => {
      this.customerSubscription = obs
        .pipe(
          filter((customer) => !!customer),
          map((customer) => customer.customerId),
          distinctUntilChanged()
        )
        .subscribe((customerId) => {
          if (customerId) {
            this.customerId = customerId.toString();
          }
        });
    });
  }

  collectPremiumPurchases(priceCode): Subject<PlatformResponse<any>> {
    const params = {
      customer_id: this.customerId,
      price_code: priceCode,
      session_token: this.userSession.sessionToken,
      clientapp: this.config.getClientApp(),
    };

    return this.webservices.post(
      "product/collect-premium-purchase",
      params as any
    );
  }

  getTaxInfo(amount, customerAccountId) {
    let obj: any = {
      customer_id: this.customerId,
      session_token: this.userSession.sessionToken,
      amount: amount,
      acct_id: customerAccountId
    }
    return this.webservices.get('product/get_tax_info', obj);
  }


  public updateAccount(obj) {
    obj  = {
      ...obj,
      customer_id: this.customerId,
      session_token: this.userSession.sessionToken,
    }
    return this.webservices.post('cashier/update-account', obj);
  }
}
